import { render } from "./Pagination.vue?vue&type=template&id=3cfd7865&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=3cfd7865&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\floresn\\source\\repos\\igx-vue-park-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfd7865"]])

export default __exports__